import React, { SVGProps } from 'react';
type Props = {} & SVGProps<SVGSVGElement>;

export default function CoordinatesIcon(props: Props) {
    return (
        <svg width="20px" height="20px" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path fill="#FFFFFF" fillOpacity={0.01} d="M0 0h48v48H0z" />
            <path d="m24 12 14 8v16l-14 8-14-8V20z" stroke="currentColor" strokeWidth={4} strokeLinejoin="round" />
            <path
                d="M24 6v6m-14 8 14 8 14-8m0 16 6 3M4 39l6-3m14-8v16"
                stroke="#FFFFFF"
                strokeWidth={1.5}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}
